export default "__VITE_ASSET__BAALMm6c__"